const login_en = require('./login.json')
export default login_en